// const root = [location.origin, 'https://www.fxyf99.com', 'https://fqyf.wts9999.net', 'https://prepare.fxyf99.com'];
const root = [location.origin, location.origin, 'https://fqyf.wts9999.net', location.origin];
// const root = ['//'+location.host, '//'+location.host, 'http://192.168.33.39:8081'];
const env = API_CONFIG.ENV;
const common = {
  version:2,//菜单版本
  channel:API_CONFIG.CHANNEL,
  test:["bz0191018029","bz0190523355"],
  api_root: root[env], //
  appId: env==1?"wx1a86bb7e7f5e7797":"wx9aa0e91be989a713",
  env: env, //环境 0测试 1正式 2本地 3预发布
}
export default common;

